import { memo } from 'react'
import { DeepPartial } from 'utility-types'
import Text from '../Common/NewText'
import Progressbar from './Progressbar'
import USStockDetailDataType from '@/components/USStocks/USStocksChildPage/utils/USStockDetail-type'

const WhatExpertsSay = memo(
  ({
    data,
  }: {
    data: DeepPartial<
      USStockDetailDataType['stockDetail']['expertSayTemplate']
    > & { footer_text?: string }
  }) => {
    const { bottom_info, chartBarData, recom, footer_text } = data

    return (
      <div>
        <div className="flex flex-col justify-start md:flex-row md:items-center md:gap-16">
          <div className="flex items-center md:w-3/4">
            {recom?.label_color && (
              <div
                className="my-6 mr-4 flex h-16 w-16 items-center justify-center rounded-full text-base font-normal md:mr-6 md:h-28 md:w-28 md:text-2xl"
                style={{
                  color: recom.label_color,
                  backgroundColor: recom.bg_color,
                }}
              >
                {recom.label}
              </div>
            )}
            <div className="h-15 flex flex-grow flex-col justify-around md:h-28">
              {chartBarData?.map((item, index) => {
                return (
                  <Progressbar
                    key={index}
                    rating={item.name ?? ''}
                    color={item.color ?? '#FFF'}
                    parameter={item.status}
                  />
                )
              })}
            </div>
          </div>
          {bottom_info?.text && (
            <Text
              appearance="body1"
              addClassName="text-brand-grey-base md:w-1/2"
            >
              {bottom_info.text}
            </Text>
          )}
        </div>
        {footer_text && (
          <div className="flex flex-1 justify-end pt-4">
            <Text appearance="caption" addClassName=" text-brand-grey-light">
              {footer_text}
            </Text>
          </div>
        )}
      </div>
    )
  },
)

WhatExpertsSay.displayName = 'WhatExpertsSay'

export default WhatExpertsSay
